/* eslint-disable max-len */
import type { IconPrimitiveProps } from 'types';

const IconSaveMe = (props: IconPrimitiveProps) => {
  const {
    size = 24,
    ...rest
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      width={size}
      height={size}
      {...rest}
    >
      <rect width={18.5} height={18.5} x={2.75} y={2.75} stroke="currentColor" rx={3.25} />
      <path fill="currentColor" d="M12.114 7.528c-1.632 0-2.82.912-2.82 2.292 0 1.26.756 1.956 2.496 2.496 1.296.396 1.644.708 1.644 1.404 0 .804-.636 1.236-1.524 1.236-.864 0-1.524-.312-2.136-.828l-.816.912c.684.672 1.668 1.14 2.988 1.14 1.98 0 3.144-1.056 3.144-2.544 0-1.56-1.008-2.16-2.46-2.616-1.38-.432-1.704-.696-1.704-1.296 0-.648.54-.984 1.284-.984.684 0 1.26.216 1.86.708l.78-.9c-.72-.66-1.524-1.02-2.736-1.02Z" />
    </svg>
  );
};
export default IconSaveMe;
